module.exports = __webpack_public_path__ + "static/media/Feed-beef.17a572b8.jpg";